import { render, staticRenderFns } from "./awaitngAssignOrders.vue?vue&type=template&id=02528d86&scoped=true&"
import script from "./awaitngAssignOrders.vue?vue&type=script&lang=js&"
export * from "./awaitngAssignOrders.vue?vue&type=script&lang=js&"
import style0 from "./awaitngAssignOrders.vue?vue&type=style&index=0&id=02528d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02528d86",
  null
  
)

export default component.exports